import { SHOW_FULFILMENT_INFO } from "../constants";

export const showFulfilmentInfo = payload => dispatch => {
  dispatch({ type: SHOW_FULFILMENT_INFO, payload });
};
